// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"594":"about","962":"store"}[chunkId] + "." + {"594":"977002f6","962":"53a37731"}[chunkId] + ".css";
};